<template>
    <v-modal-validated title="Editar tarea"
                       accept-button-text="Guardar"
                       close-button-text="Cerrar"
                       id="add-task-modal"
                       size="xl"
                       :rules="rules"
                       @closed="closeModal"
                       @accepted="editTask">

        <div class="row user-form">
            <div class="col-6 d-flex flex-column">
                <div class="form-group">
                    <label>Nombre*:</label>

                    <Field type="text" id="name" name="name" class="form-control" v-model="task.name"/>

                    <ErrorMessage name="name"/>
                </div>

                <div class="form-group flex-grow-1 d-flex flex-column">
                    <label>Descripción*:</label>

                    <Field as="textarea" name="description" class="form-control textarea flex-grow-1"
                           v-model="task.description"/>

                    <ErrorMessage class="textarea-alert mt-1" name="description"/>
                </div>

                <div class="form-group">
                    <p class="mb-0"><span class="fw-bold">Autor: </span>{{ selectedTask.author.name }} ({{ selectedTask.author.email }})</p>
                </div>
            </div>

            <div class="col-6">
                <div class="form-group">
                    <p class="fw-bold mb-1">Tipo:</p>

                    <p>{{ task.type }}</p>
                </div>

                <div class="form-group">
                    <label>Estado:</label>

                    <Field type="text" name="status" class="form-control" aria-label="status" v-model="task.status">
                        <select class="form-select"
                                v-model="task.status">
                            <option value="Abierta">Abierta</option>
                            <option value="Agente asignado">Agente asignado</option>
                            <option value="En proceso de resolución">En proceso de resolución</option>
                            <option value="Cerrada">Cerrada</option>
                        </select>
                    </Field>

                    <ErrorMessage name="type"/>
                </div>

                <div class="form-group">
                    <label>Origen*:</label>

                    <Field type="text" name="origin" class="form-control" v-model="task.origin">
                        <select class="form-select"
                                name="origin"
                                aria-label="Origen"
                                v-model="task.origin">
                            <option value="Consulta cliente">Consulta cliente</option>
                            <option value="Tarea interna">Tarea interna</option>
                            <option value="Otros">Otros</option>
                        </select>
                    </Field>

                    <ErrorMessage name="origin"/>
                </div>

                <div class="row">
                    <div class="form-group col-6">
                        <label>Responsable: </label>

                        <select class="form-control" disabled v-if="users.length === 0">
                            <option selected>- No existen usuarios en la aplicación -</option>
                        </select>

                        <div class="input-group" v-else>
                            <Field type="text"
                                   id="user_id"
                                   name="user_id"
                                   class="form-control"
                                   v-model="task.user_id">

                                <v-select-jq aria-label="Equipo"
                                             parent-id="add-task-modal"
                                             placeholder="- Seleccionar -"
                                             ref="selectUsers"
                                             :options="users"
                                             :value="task.user_id"
                                             @update:modelValue="task.user_id = $event">
                                </v-select-jq>
                            </Field>

                            <button class="delete-date" @click="$refs.selectUsers.removeAll();"
                                    :disabled="!task.user_id  ? true : null">
                                <span class="uq-icon bi-x-lg"></span>
                            </button>
                        </div>

                        <ErrorMessage name="user_id"/>
                    </div>

                    <div class="form-group col-6">
                        <label>Equipo: </label>

                        <select class="form-control" disabled v-if="roles.length === 0">
                            <option selected>- No existen equipos en la aplicación -</option>
                        </select>

                        <div class="input-group" v-else>
                            <Field type="text"
                                   id="role_id"
                                   name="role_id"
                                   class="form-control"
                                   v-model="task.role_id">

                                <v-select-jq aria-label="Rol"
                                             parent-id="add-task-modal"
                                             placeholder="- Seleccionar -"
                                             ref="selectRoles"
                                             :options="roles"
                                             :value="task.role_id"
                                             @update:modelValue="task.role_id = $event">
                                </v-select-jq>
                            </Field>


                            <button class="delete-date " @click="$refs.selectRoles.removeAll()"
                                    :disabled="!task.role_id  ? true : null">
                                <span class="uq-icon bi-x-lg"></span>
                            </button>
                        </div>

                        <ErrorMessage name="role_id"/>
                    </div>
                </div>

                <div class="form-group">
                    <label>Fecha límite:</label>

                    <div class="input-group">
                        <Field type="date" :disabled="task.type === 'Incidencia' && !!task.end_date" name="end_date" class="form-control" v-model="task.end_date"/>

                        <button class="delete-date" @click="task.end_date = ''"
                                :disabled="!task.end_date ? true : null"
                                v-if="task.type !== 'Incidencia'">
                            <span class="uq-icon bi-x-lg"></span>
                        </button>

                        <ErrorMessage name="end_date"/>
                    </div>
                </div>

                <div class="row">
                    <div class="form-group col-6">
                        <label>Cliente: </label>
                        <select class="form-control" disabled v-if="clients.length === 0">
                            <option selected>- No existen clientes en la aplicación -</option>
                        </select>

                        <div class="input-group" v-else>
                            <Field type="text"
                                   id="client_id"
                                   name="client_id"
                                   class="form-control"
                                   v-model="task.client_id">

                                <v-select-jq aria-label="Cliente"
                                             ref="selectClient"
                                             parent-id="add-task-modal"
                                             placeholder="- Seleccionar -"
                                             :options="clients"
                                             :value="task.client_id"
                                             @update:modelValue="task.client_id = $event">
                                </v-select-jq>
                            </Field>

                            <button class="delete-date" @click="$refs.selectClient.removeAll();"
                                    :disabled="!task.client_id  ? true : null">
                                <span class="uq-icon bi-x-lg"></span>
                            </button>
                        </div>

                        <ErrorMessage name="client_id"/>
                    </div>

                    <div class="form-group col-6">
                        <label>Expediente: </label>

                        <select class="form-control" disabled v-if="expedients.length === 0">
                            <option selected>- No existen expedientes en la aplicación -</option>
                        </select>

                        <div class="input-group" v-else>
                            <Field type="text"
                                   id="expedient_id"
                                   name="expedient_id"
                                   class="form-control"
                                   v-model="task.expedient_id">

                                <v-select-jq aria-label="Expediente"
                                             ref="selectExpedient"
                                             parent-id="add-task-modal"
                                             placeholder="- Seleccionar -"
                                             :options="expedients"
                                             :value="task.expedient_id"
                                             @update:modelValue="task.expedient_id = $event">
                                </v-select-jq>
                            </Field>

                            <button class="delete-date" @click="$refs.selectExpedient.removeAll();"
                                    :disabled="!task.expedient_id  ? true : null">
                                <span class="uq-icon bi-x-lg"></span>
                            </button>
                        </div>

                        <ErrorMessage name="expedient_id"/>
                    </div>
                </div>
            </div>
        </div>
    </v-modal-validated>
</template>

<script>
import VModalValidated from "../../general/VModalValidated";
import {ErrorMessage, Field, Form} from "vee-validate";
import * as yup from "yup";
import VSelectJq from "../../general/VSelectJQ";
import {getAllClientsWithoutPagination} from "../../../helpers/requests/RequestsClients";
import {withTimeout} from "../../../helpers/requests/RequestsCore";
import {getExpedients} from "../../../helpers/requests/RequestsExpedients";
import {getRoles} from "../../../helpers/requests/RequestsRoles";
import {getUsers} from "../../../helpers/requests/RequestsUsers";
import {updateTask} from "../../../helpers/requests/RequestsTasks";

export default {
    name: "TasksListEditModal",
    props: {
        selectedTask: {
            type: Object,
            require: true,
        }
    },
    components: {
        VSelectJq,
        VModalValidated,
        Form,
        Field,
        ErrorMessage
    },
    data() {
        return {
            clients: [],
            expedients: [],
            roles: [],
            users: [],

            task: {},

            rules: {
                name: yup.string().required('Debes incluir un nombre'),
                origin: yup.string().required('Debes incluir un origen'),
                description: yup.string().required('Debes incluir una descripción'),
                //end_date: yup.string().nullable(),
                role_id: yup.string().nullable(),
                client_id: yup.string().nullable(),
                expedient_id: yup.string().nullable(),
                user_id: yup.string().nullable(),
            }
        }
    },
    async mounted() {
        this.task = {...this.selectedTask};

        // We need that date without ' 00:00:00' ending
        if (this.task.end_date) {
            this.task.end_date = this.task.end_date.split(' ')[0];
        }

        await Promise.all([
            this.loadAvailableClients(),
            this.loadAvailableExpedients(),
            this.loadAvailableRoles(),
            this.loadAvailableUsers(),
        ]);
    },
    methods: {
        formatRoleName(name) {
            return name.charAt(0).toUpperCase() + name.slice(1).replaceAll('_', ' ');
        },
        async loadAvailableClients() {
            let clients = await getAllClientsWithoutPagination();

            if (!clients.meta) {
                this.clients = Object.values(clients).map((client) => {
                    return {id: client.id, text: '(' + client.code + ') ' + client.fullName}
                });
            }
        },
        async loadAvailableExpedients() {
            // TODO: Load select cliente expedients
            let expedients = await getExpedients();

            if (!expedients.meta) {
                this.expedients = Object.values(expedients).map((expedient) => {
                    return {id: expedient.id, text: expedient.name + ' (' + expedient.entities[0].name + ' - ' + expedient.entities[0].short_name + ')'};
                });
            }
        },
        async loadAvailableRoles() {
            let roles = await getRoles();

            if (!roles.meta) {
                this.roles = Object.values(roles).map((role) => {
                    return {id: role.id, text: this.formatRoleName(role.name)};
                });
            }
        },
        async loadAvailableUsers() {
            let users = await getUsers();

            if (!users.meta) {
                this.users = Object.values(users).map((user) => {
                    return {id: user.id, text: user.name + ' (' + user.email + ')'};
                });
            }
        },
        search() {
            this.timers.search = withTimeout(async () => {
                this.filters.page = 1;
                await this.doSearch();
            }, this.timers.search, 250);
        },
        async editTask(data) {
            try {
                data.id = this.task.id;
                data.type = this.task.type;

                await updateTask(data);

                this.$store.dispatch('app/setToastMessage', 'Cambios guardados con éxito');

                this.$emit('task-updated');
            } catch (e) {
                this.$store.dispatch('app/setErrorToastMessage', 'Error al guardar los cambios');

                this.closeModal();
            }
        },
        closeModal() {
            this.$emit('closed');
        }
    }
}
</script>
